export default __webpack_public_path__ + "static/FancyMediaContentEleven-f2b91b0febc1ae0785d2f912fe64f7c6.webp";